import { render, staticRenderFns } from "./ModifyHistoryModal.vue?vue&type=template&id=d03b153e"
import script from "./ModifyHistoryModal.vue?vue&type=script&lang=ts"
export * from "./ModifyHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d03b153e')) {
      api.createRecord('d03b153e', component.options)
    } else {
      api.reload('d03b153e', component.options)
    }
    module.hot.accept("./ModifyHistoryModal.vue?vue&type=template&id=d03b153e", function () {
      api.rerender('d03b153e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/ModifyHistoryModal.vue"
export default component.exports